<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="dedication" id="_idParaDest-1" lang="en-US" xml:lang="en-US"><a id="_idTextAnchor000"></a>For Laurence, who was my inspiration.<br/>E.<span xml:lang="ar-SA"> </span>C.<br/>In memory of Nana Pat, who really did make our childhood magical.<br/>K.<span xml:lang="ar-SA"> </span>C.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled128.vue?78fbebbe